/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { LeadSOffenderRecord } from './LeadSOffenderRecord';
import {
    LeadSOffenderRecordFromJSON,
    LeadSOffenderRecordFromJSONTyped,
    LeadSOffenderRecordToJSON,
    LeadSOffenderRecordToJSONTyped,
} from './LeadSOffenderRecord';

/**
 * 
 * @export
 * @interface UpdateLeadSOffenderRecordById200Response
 */
export interface UpdateLeadSOffenderRecordById200Response {
    /**
     * 
     */
    data?: LeadSOffenderRecord;
}

/**
 * Check if a given object implements the UpdateLeadSOffenderRecordById200Response interface.
 */
export function instanceOfUpdateLeadSOffenderRecordById200Response(value: object): value is UpdateLeadSOffenderRecordById200Response {
    return true;
}

export function UpdateLeadSOffenderRecordById200ResponseFromJSON(json: any): UpdateLeadSOffenderRecordById200Response {
    return UpdateLeadSOffenderRecordById200ResponseFromJSONTyped(json, false);
}

export function UpdateLeadSOffenderRecordById200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateLeadSOffenderRecordById200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : LeadSOffenderRecordFromJSON(json['data']),
    };
}

export function UpdateLeadSOffenderRecordById200ResponseToJSON(json: any): UpdateLeadSOffenderRecordById200Response {
    return UpdateLeadSOffenderRecordById200ResponseToJSONTyped(json, false);
}

export function UpdateLeadSOffenderRecordById200ResponseToJSONTyped(value?: UpdateLeadSOffenderRecordById200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': LeadSOffenderRecordToJSON(value['data']),
    };
}

